export class TournamentRegister
{
 
    TournamentId:number = 0;
}